import { DiscountTypes } from "@/common/enums";

export default class LatPaySiteSettingsModel {
    company: string = "";
    accountId: string = "";
    storeReference: string = "";
    storeId: string = "";
}
